import escapeRegExp from 'lodash.escaperegexp';
import he from 'he';

export const defaultDisplay = (display) => (option) => {
  return he.decode(option[display]);
};

export const defaultOptionValue = (option) => option.id ?? option.key;

export const getFilterFn = ({ filter, loadOptions, sriLoadOptions }) => {
  if (filter) return filter;
  if (loadOptions || sriLoadOptions) return null;
  return ({ data }, str) => {
    if (!str || str.trim().length === 0) return true;
    const regExp = new RegExp(escapeRegExp(str), 'gi');
    return regExp.test(data.name || data.$$displayName);
  };
};
